var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout olap", attrs: { "data-code": _vm.code } },
    [
      _vm.loading
        ? _c("loader", {
            attrs: {
              active: _vm.loading,
              label: "Данные загружаются",
              height: 400,
            },
          })
        : _vm.noReportError
        ? _c(
            "div",
            [
              _c("c-button", {
                attrs: {
                  size: "small",
                  label: "К списку отчетов",
                  icon: {
                    icon: "back",
                  },
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "olap",
                      query: { code: _vm.code },
                    })
                  },
                },
              }),
              _c("div", { staticClass: "no-report" }, [
                _vm._v("Отчет не найден"),
              ]),
            ],
            1
          )
        : [
            _c("m-confirm", { ref: "confirmModal", attrs: { mode: "danger" } }),
            _c("m-highlight-data-modal", {
              attrs: { active: _vm.isShowHighlightDataModal },
              on: {
                close: function ($event) {
                  _vm.isShowHighlightDataModal = false
                },
              },
            }),
            _c("m-save-olap-report", {
              attrs: {
                code: _vm.code,
                active: _vm.isShowSaveOlapReportModal,
                "name-report": _vm.reportName,
              },
              on: {
                close: function ($event) {
                  _vm.isShowSaveOlapReportModal = false
                },
                save: _vm.save,
              },
            }),
            _c("m-report", {
              ref: "reportModal",
              attrs: { code: _vm.code },
              on: {
                updated: _vm.onReportUpdated,
                removed: _vm.onReportRemoved,
              },
            }),
            _c("m-description", {
              ref: "description",
              attrs: { code: _vm.code, "can-edit": true },
              on: { edit: _vm.editDescription },
            }),
            _c("div", { staticClass: "olap-header" }, [
              _c("div", { staticClass: "olap-header-title" }, [
                _vm._v(_vm._s(_vm.reportName)),
              ]),
              _c(
                "div",
                { staticClass: "olap-header-actions" },
                [
                  _vm.report
                    ? _c("responsible", {
                        staticClass: "olap-responsible",
                        attrs: { worker: _vm.responsible },
                        on: { assign: _vm.assignResponsible },
                      })
                    : _vm._e(),
                  _vm.report
                    ? _c("c-button", {
                        staticClass: "olap-description",
                        attrs: {
                          size: "small",
                          icon: {
                            icon: "comment",
                            activeColor: "white",
                          },
                          tooltip: {
                            text: "Добавить описание",
                            activeText: "Просмотр описания",
                          },
                          "active-color": "blue",
                          active: _vm.report.hasDescription,
                        },
                        on: {
                          click: function ($event) {
                            _vm.report.hasDescription
                              ? _vm.showDescription()
                              : _vm.addDescription()
                          },
                        },
                      })
                    : _vm._e(),
                  _c("c-button-dropdown", {
                    staticClass: "olap-actions",
                    attrs: {
                      icon: "arrow",
                      type: "dropdown",
                      label: "Действия",
                      dropdown: {
                        position: "left",
                        items: [
                          {
                            icon: "excel",
                            iconColor: "success",
                            label: "Выгрузить в Excel",
                            emit: "exportToExcel",
                          },
                          {
                            icon: "edit",
                            label: "Редактировать настройки",
                            emit: "edit",
                          },
                          {
                            icon: "trash",
                            iconColor: "secondary",
                            label: "Удалить",
                            emit: "remove",
                          },
                        ],
                      },
                    },
                    on: {
                      exportToExcel: _vm.exportToExcel,
                      edit: _vm.editReport,
                      remove: _vm.removeReport,
                    },
                  }),
                  _c("c-button", {
                    staticClass: "olap-list",
                    attrs: {
                      size: "small",
                      label: "К списку отчетов",
                      icon: {
                        icon: "back",
                      },
                      responsive: true,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "olap",
                          query: { code: _vm.code },
                        })
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "olap-filters" },
              [
                _vm.hasPeriodFilter
                  ? [
                      _c("c-input", {
                        ref: "datepicker",
                        staticClass: "olap-filters-period",
                        attrs: {
                          placeholder: "00.00.0000 - 00.00.0000",
                          type: "period",
                          icon: "calendar",
                          "icon-right": true,
                          clearable: true,
                        },
                        model: {
                          value: _vm.form.period,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "period", $$v)
                          },
                          expression: "form.period",
                        },
                      }),
                      _c("c-button", {
                        staticClass: "olap-filters-apply",
                        attrs: { label: "Показать", color: "primary" },
                        on: { click: _vm.apply },
                      }),
                    ]
                  : _vm._e(),
                _c("responsible", {
                  staticClass: "olap-responsible",
                  attrs: { worker: _vm.responsible },
                  on: { assign: _vm.assignResponsible },
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "olap__actions d-flex justify-content-between" },
              [
                _c(
                  "div",
                  { staticClass: "olap__params" },
                  [
                    _vm.switcherLocal !== "viewing"
                      ? _c("c-button", {
                          staticClass: "olap-params-show-hide",
                          attrs: {
                            size: "small",
                            icon: "settings",
                            active: _vm.isShowFields,
                            label: _vm.isShowFields
                              ? "Скрыть параметры"
                              : "Показать параметры",
                            responsive: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.isShowFields = !_vm.isShowFields
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _vm.report
                      ? _c("chat-button", {
                          staticClass: "olap__comments",
                          attrs: {
                            entity: "olap_report",
                            "entity-id": _vm.reportId,
                            "can-edit": !!_vm.report.chat,
                            "hide-empty": !_vm.report.chat,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "olap__view" },
                      [
                        _c("c-switcher", {
                          staticClass: "h-switcher",
                          attrs: {
                            type: "group",
                            items: [
                              { label: "Настройка", value: "customization" },
                              { label: "Просмотр", value: "viewing" },
                            ],
                            disabled: _vm.isDataLoading,
                          },
                          model: {
                            value: _vm.switcherLocal,
                            callback: function ($$v) {
                              _vm.switcherLocal = $$v
                            },
                            expression: "switcherLocal",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm.isDataLoading
              ? _c("loader", {
                  staticClass: "couriers-report-table__loader",
                  attrs: {
                    active: _vm.isDataLoading,
                    height: "500",
                    label: "Данные загружаются",
                  },
                })
              : _vm._e(),
            !_vm.isDataLoading
              ? _c(
                  "div",
                  { staticClass: "olap-report" },
                  [
                    _c("wj-pivot-panel", {
                      staticClass: "olap-wj-panel",
                      class: {
                        "olap-wj-panel-hide":
                          !_vm.isShowFields || _vm.switcherLocal === "viewing",
                      },
                      attrs: {
                        id: "pivot-panel-fields",
                        initialized: _vm.initPivotPanel,
                        "items-source": _vm.ng,
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "olap-report-grid",
                        class: {
                          "olap-report-grid-max-width":
                            _vm.switcherLocal === "viewing" ||
                            !_vm.isShowFields,
                        },
                      },
                      [
                        _vm.switcherLocal === "customization"
                          ? _c("wj-pivot-panel", {
                              staticClass: "olap-wj-panel",
                              class: {
                                "olap-wj-panel-viewing":
                                  _vm.switcherLocal === "viewing",
                              },
                              attrs: {
                                id: "pivot-panel-areas",
                                "items-source": _vm.ng,
                              },
                            })
                          : _vm._e(),
                        _c("wj-pivot-grid", {
                          staticClass: "olap-wj-grid",
                          style: {
                            "max-height":
                              _vm.switcherLocal === "viewing"
                                ? "calc(100vh - 280px)"
                                : "",
                          },
                          attrs: {
                            "items-source": _vm.ng,
                            initialized: _vm.initPivotGrid,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("wj-popup", {
                      attrs: {
                        id: "wijmoPopup",
                        initialized: _vm.initPopupForm,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.switcherLocal === "customization"
              ? _c(
                  "div",
                  { staticClass: "olap-buttons" },
                  [
                    _c("c-button", {
                      staticClass: "olap-buttons-delete",
                      attrs: { color: "secondary", label: "Удалить" },
                      on: { click: _vm.removeReport },
                    }),
                    _c("c-button", {
                      staticClass: "olap-buttons-cancel",
                      attrs: { label: "Отменить" },
                      on: { click: _vm.cancel },
                    }),
                    _c("c-button", {
                      staticClass: "olap-buttons-save",
                      attrs: { color: "primary", label: "Сохранить" },
                      on: {
                        click: function ($event) {
                          _vm.isShowSaveOlapReportModal = true
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }